import mixpanel from 'mixpanel-browser';

mixpanel.init('d760801ec3d2754b0b447e9ef44aa9c6');

export default mixpanel;
